import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import _ from 'lodash';
import { getDashboardJobsAction } from '../../../actions/dashboard';
import DashboardColumn from './DashboardColumn';
import { dashboardDaysQuantity } from '../../../constants/general';
import { monthDayYearFormat, dashboardNavDateFormat } from '../../../constants/date';

class Dashboard extends Component {
  static propTypes = {
    dashboard: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    getDashboardJobsAction: PropTypes.func.isRequired
  };

  now = moment();

  state = {
    startOfWeek: this.now.startOf('isoweek'),
    endOfWeek: moment().endOf('isoweek'),
    shouldHide: false
  };

  componentDidMount () {
    const { getDashboardJobsAction } = this.props;
    const { startOfWeek } = this.state;
    const weekMonday = startOfWeek.format(monthDayYearFormat);
    getDashboardJobsAction(weekMonday, dashboardDaysQuantity);
  }

  hideFilled = () => {
    this.setState(state => ({
      shouldHide: !state.shouldHide
    }));
  };

  showPreviousWeek = () => {
    const { startOfWeek, endOfWeek } = this.state;
    startOfWeek.subtract(7, 'days');
    endOfWeek.subtract(7, 'days');
    this.changeWeek(startOfWeek, endOfWeek);
  };

  showNextWeek = () => {
    const { startOfWeek, endOfWeek } = this.state;
    startOfWeek.add(7, 'days');
    endOfWeek.add(7, 'days');
    this.changeWeek(startOfWeek, endOfWeek);
  };

  changeWeek = (startOfWeek, endOfWeek) => {
    this.setState({
      startOfWeek,
      endOfWeek
    });
    this.props.getDashboardJobsAction(startOfWeek.format(monthDayYearFormat), dashboardDaysQuantity);
  };

  renderDashBoardColumns = () => {
    let { dashboard } = this.props;
    const dayOfWeek = this.state.startOfWeek.clone();
    const dashboardColumns = [];
    dashboard = _.keyBy(dashboard, 'day_index');
    for (let i = 0; i < dashboardDaysQuantity; i++) {
      const columnData = dashboard[i];
      let dayJobs = [];
      if (columnData) {
        dayJobs = columnData.jobs;
      }
      if (i !== 0) {
        dayOfWeek.add(1, 'days');
      }
      dashboardColumns.push(
        <DashboardColumn
          history={this.props.history}
          dayJobs={dayJobs}
          dayOfWeek={dayOfWeek.clone()}
          key={i}
          shouldHide={this.state.shouldHide}
        />
      );
    }
    return dashboardColumns;
  };

  render () {
    const { startOfWeek, endOfWeek, shouldHide } = this.state;
    return (
      <div>
        <div className='top-header'>
          <div className='page-title'>
            <div className='title-icon'>
              <FontAwesomeIcon icon={faCalendarAlt} size='lg' />
            </div>
            <h3>Dashboard</h3>
          </div>
        </div>
        <div className='tabs-wrapper'>
          <div className='tab active'>Jobs</div>
        </div>
        <div className='week-number'>
          <div className='hard-left'>&nbsp;</div>
          <div
            className='change-week-arrow'
            onClick={this.showPreviousWeek}
          >
            <FontAwesomeIcon icon={faChevronLeft} size='lg' />
          </div>
          <p><b>{`${startOfWeek.format(dashboardNavDateFormat)} - ${endOfWeek.format(dashboardNavDateFormat)}`}</b></p>
          <div
            className='change-week-arrow'
            onClick={this.showNextWeek}
          >
            <FontAwesomeIcon icon={faChevronRight} size='lg' />
          </div>
          {shouldHide &&
          <div
            className='other-button ok-btn hard-right'
            onClick={this.hideFilled}
          >
            Show Filled
          </div>
          }
          {!shouldHide &&
          <div
            className='other-button warning-btn hard-right'
            onClick={this.hideFilled}
            >
            Hide Filled
            </div>
          }
        </div>
        <div className='board-wrapper'>
          {this.renderDashBoardColumns()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard: state.dashboard
  };
};

export default connect(mapStateToProps, { getDashboardJobsAction })(Dashboard);



// WEBPACK FOOTER //
// ./src/components/app/dashboard/index.js